<p-blockUI [blocked]="blocked">
  <div id="center" style="margin-top:260px; margin-left:800px;">
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<div class="content-left-top-cornor">
  <p-tabView (onChange)="onTabChange($event)" [activeIndex]="index">
    
    <p-tabPanel [headerStyleClass]="getCSSClassForPanel(0)" header="Plate Preparation">
      <app-ma-plate-preparation [isPlatePreparationSelectedFromSamplesComponent]="platePreparationTabActive" [machinesList]="machinesList" [scannedPlateID]="scannedPlateID" #platePreparation></app-ma-plate-preparation>
    </p-tabPanel>

    <p-tabPanel [headerStyleClass]="getCSSClassForPanel(1)" header="Array Preparation">
      <ng-template pTemplate="content">
        <app-ma-beadchip-loading [isBeadChipLoadingSelectedFromSamplesComponent]="beadChipLoadingTabActive" [scannedPlateID]="scannedPlateID" [selectedPlateType]="entityType" #beadchipLoading></app-ma-beadchip-loading>
      </ng-template>
    </p-tabPanel>

    <p-tabPanel [headerStyleClass]="getCSSClassForPanel(2)" *ngIf="isResultEvaluationOn" header="Evaluation">
      <ng-template pTemplate="content">
        <app-ma-result-evaluation [isResultEvaluationSelectedFromSamplesComponent]="resultEvaluationTabActive" [scannedPlateID]="scannedPlateID" [selectedPlateType]="entityType" #resultEvaluation></app-ma-result-evaluation>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>